import { makeStyles } from "../Utilities/ThemeHelper";
const useStyles = makeStyles(theme => ({
  dialog: {
    borderRadius: 1,
    maxHeight: "calc(100svh - 96px)",
    height: ({
      fullHeight
    }) => fullHeight ? "100%" : "auto",
    ...theme.scrollbars?.main
  },
  dialogContent: {
    position: "relative",
    ...theme.scrollbars?.main,
    minHeight: 0
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(2),
    top: theme.spacing(2)
  },
  title: {
    padding: "26px 86px 16px 25px"
  },
  buttons: {
    margin: 0,
    padding: theme.spacing(2)
  }
}));
export default useStyles;